import { render, staticRenderFns } from "./update-quiz-reward.html?vue&type=template&id=53d53e94&scoped=true&"
import script from "./update-quiz-reward.js?vue&type=script&lang=js&"
export * from "./update-quiz-reward.js?vue&type=script&lang=js&"
import style0 from "./update-quiz-reward.scss?vue&type=style&index=0&id=53d53e94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d53e94",
  null
  
)

export default component.exports